import { cn } from '@/lib/utils';
import React from 'react';
import { SeverityEnum } from './enums/severity';

const severityColorClasses: Record<SeverityEnum, string> = {
  error:
    'bg-red-50 text-red-700 ring-1 ring-inset ring-red-200 dark:bg-red-900/20 dark:text-red-300 dark:ring-red-800',
  warning:
    'bg-yellow-50 text-yellow-700 ring-1 ring-inset ring-yellow-200 dark:bg-yellow-900/20 dark:text-yellow-300 dark:ring-yellow-800',
  success:
    'bg-green-50 text-green-700 ring-1 ring-inset ring-green-200 dark:bg-green-900/20 dark:text-green-300 dark:ring-green-800',
  info: 'bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-200 dark:bg-blue-900/20 dark:text-blue-300 dark:ring-blue-800',
  note: 'bg-gray-50 text-gray-700 ring-1 ring-inset ring-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:ring-gray-700',
};

interface StatusBadgeProps {
  status: string;
  severity: SeverityEnum;
  square?: boolean;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  severity,
  square = false,
  className = '',
}) => (
  <span
    className={cn(
      'inline-flex items-center',
      'px-2 py-0.5',
      'text-xs font-medium',
      square ? 'rounded-md' : 'rounded-full',
      severityColorClasses[severity],
      className
    )}
  >
    {status}
  </span>
);
